import script from "./wjadd.vue?vue&type=script&setup=true&lang=js"
export * from "./wjadd.vue?vue&type=script&setup=true&lang=js"

import "./wjadd.vue?vue&type=style&index=0&id=072c4ebf&lang=scss&scoped=true"
import "./wjadd.vue?vue&type=style&index=1&id=072c4ebf&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-072c4ebf"]])

export default __exports__